'use strict';
require('./sticker-emoji-widget');
const mmWidgets = require('../widgets/mm-widgets');
mmWidgets.fn.stickerCategoryWidget = function (params) {
	const {stickersEditorModel, category, action, additionalClass} = params;
	if (!stickersEditorModel || !category || !action) {
		throw new Error('invalid-args');
	}

	return mmWidgets.each(this, function () {
		const widget = this.attr('data-mm-category', category),
			stickerTemplate = widget.find('[data-mm-role~="sticker-template"]').detach(),
			stickerContainer = widget.find('[data-mm-role~="sticker-container"]'),
			stickersForCategory = stickersEditorModel.getStickersForCategory(category);
		widget.find('[data-mm-role~="category-name"]').text(category);
		if (additionalClass) {
			widget.addClass(additionalClass);
		}
		if (stickersForCategory.length > 20) {
			widget.addClass('show-less');
		}
		stickersForCategory.forEach((sticker) => {
			stickerTemplate.clone().appendTo(stickerContainer).stickerEmojiWidget({stickersEditorModel, sticker, action});
		});
		widget.find('[data-mm-role~="show-less"]').click(function () {
			widget.removeClass('show-more').addClass('show-less');
		});
		widget.find('[data-mm-role~="show-more"]').click(function () {
			widget.removeClass('show-less').addClass('show-more');
		});
	});
};
